import React from 'react';
import { ResearcherTemplate, ResearcherTemplateData } from '../../templates/ResearcherTemplate';

// Reliable placeholder images
const PLACEHOLDERS = {
    avatar: 'https://picsum.photos/seed/researcher/400/400',
    research1: 'https://picsum.photos/seed/research1/600/400',
    research2: 'https://picsum.photos/seed/research2/600/400',
    research3: 'https://picsum.photos/seed/research3/600/400',
    research4: 'https://picsum.photos/seed/research4/600/400',
};

// Sample data - inspired by Balaji-style researcher archetype
const sampleResearcherData: ResearcherTemplateData = {
    identity: {
        name: 'Dr. Alex Chen',
        handle: '@alexchencrypto',
        avatar: PLACEHOLDERS.avatar,
        bio: 'Former Stanford CS professor turned crypto researcher. Writing about network states, decentralized identity, and the future of coordination. Author of "Crypto Sovereign" and lead researcher at the Network State Institute.',
    },

    topics: [
        'Network States',
        'Decentralized Identity',
        'Token Economics',
        'DAO Governance',
        'Zero Knowledge',
        'MEV Research',
        'Coordination Theory',
        'Digital Nations',
    ],

    stats: [
        { value: '847K', label: 'Followers' },
        { value: '2.4M', label: 'Thread Views' },
        { value: '156', label: 'Research Papers' },
        { value: '12', label: 'Years in Crypto' },
    ],

    threads: [
        {
            id: '1',
            title: 'The Network State in 2026: A Progress Report',
            preview: 'Three years after the book launched, we have 47 proto-network states with over $2B in collective treasuries. Here\'s what we\'ve learned about digital-first nations...',
            category: 'Network States',
            date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
            likes: 14200,
            retweets: 3400,
            link: '#',
        },
        {
            id: '2',
            title: 'Why ZK-SNARKs Will Replace Every Privacy System',
            preview: 'A deep technical thread on the cryptographic revolution happening in plain sight. Zero-knowledge proofs are about to make all previous privacy tech obsolete. Here\'s why...',
            category: 'Zero Knowledge',
            date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
            likes: 8700,
            retweets: 2100,
            link: '#',
        },
        {
            id: '3',
            title: 'MEV: The $40B/Year Shadow Economy of Ethereum',
            preview: 'Most users don\'t realize they\'re paying an invisible tax on every transaction. This thread breaks down MEV, who extracts it, and the solutions being built...',
            category: 'MEV Research',
            date: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
            likes: 12400,
            retweets: 2800,
            link: '#',
        },
        {
            id: '4',
            title: 'The DAO Governance Trilemma (and how to solve it)',
            preview: 'Every DAO faces a fundamental trilemma: participation, expertise, and decentralization. You can optimize for two but never three. Unless you use this framework...',
            category: 'DAO Governance',
            date: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000),
            likes: 6200,
            retweets: 1500,
            link: '#',
        },
    ],

    deepDives: [
        {
            id: '1',
            title: 'The Mathematics of Token Bonding Curves',
            excerpt: 'A rigorous analysis of bonding curves, their mathematical properties, and optimal curve selection for different use cases.',
            category: 'Token Economics',
            image: PLACEHOLDERS.research1,
            link: '#',
        },
        {
            id: '2',
            title: 'Decentralized Identity: Technical Landscape 2026',
            excerpt: 'Comprehensive survey of DID methods, verifiable credentials, and the standards driving self-sovereign identity.',
            category: 'Identity',
            image: PLACEHOLDERS.research2,
            link: '#',
        },
        {
            id: '3',
            title: 'Fork Theory: When Communities Split',
            excerpt: 'Analyzing 127 major crypto forks to understand the social and technical conditions that lead to community divergence.',
            category: 'Research',
            image: PLACEHOLDERS.research3,
            link: '#',
        },
        {
            id: '4',
            title: 'Layer 2 Economics: A Game-Theoretic Analysis',
            excerpt: 'How rollups compete, coordinate, and evolve. Modeling the long-term equilibrium of the L2 landscape.',
            category: 'Economics',
            image: PLACEHOLDERS.research4,
            link: '#',
        },
    ],

    publications: [
        {
            title: 'The Network State (Book)',
            source: 'Published by 1729 Press',
            icon: '📚',
            link: '#',
        },
        {
            title: 'Crypto Sovereign Newsletter',
            source: 'Substack • 45,000 subscribers',
            icon: '📰',
            link: '#',
        },
        {
            title: 'ZK Research Papers',
            source: 'arXiv • 23 papers',
            icon: '📄',
            link: '#',
        },
        {
            title: 'Network State Institute',
            source: 'Research organization',
            icon: '🏛️',
            link: '#',
        },
    ],

    newsletter: {
        title: 'Crypto Sovereign Weekly',
        description: 'Join 45,000+ readers. Weekly deep-dives on crypto research, network states, and the future of digital nations.',
        buttonText: 'Subscribe Free',
    },

    social: {
        twitter: 'https://twitter.com/alexchencrypto',
        substack: 'https://cryptosovereign.substack.com',
        linkedin: 'https://linkedin.com/in/alexchen',
        github: 'https://github.com/alexchen',
    },
};

const ResearcherDemo: React.FC = () => {
    return <ResearcherTemplate data={sampleResearcherData} />;
};

export default ResearcherDemo;
